import { CajaMovimiento } from "@/shared/types/caja-movimiento";
import SharedViewCajaMovimiento, { SharedViewCajaMovimientoProps } from "../../shared/components/shared-view-caja-movimiento";

interface ViewCajaActualMovimientoProps extends SharedViewCajaMovimientoProps {
    cajaMovimiento: CajaMovimiento
}

export default function ViewCajaActualMovimiento({ cajaMovimiento, ...props }: ViewCajaActualMovimientoProps) {
    return <SharedViewCajaMovimiento cajaMovimiento={cajaMovimiento} {...props} />
}